import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  AirlineModel,
  AirlineMutationInput,
  AirlineDeleteInput,
  AirlineUpdateInput,
} from './model';

export function useCreateAirline(
  options?: UseMutationOptions<
    ApiResult<AirlineModel>,
    ApiError,
    AirlineMutationInput
  >,
): UseMutationResult<ApiResult<AirlineModel>, ApiError, AirlineMutationInput> {
  return useMutation<ApiResult<AirlineModel>, ApiError, AirlineMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: 'airlines',
        method: 'POST',
        classType: AirlineModel,
        body,
      });
    },
    options,
  );
}

export function useUpdateAirline(
  options?: UseMutationOptions<
    ApiResult<AirlineModel>,
    ApiError,
    AirlineUpdateInput
  >,
): UseMutationResult<ApiResult<AirlineModel>, ApiError, AirlineUpdateInput> {
  return useMutation<ApiResult<AirlineModel>, ApiError, AirlineUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `airlines/${body.airlineId}`,
        method: 'PUT',
        classType: AirlineModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useDeleteAirline(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    AirlineDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, AirlineDeleteInput> {
  return useMutation<{ message: string }, ApiError, AirlineDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `airlines/${body.airlineId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}
